export class RejectSurveyDto {
  surveyId: string;
  validatorRemark: string;

  constructor(data: { surveyId: string; validatorRemark: string }) {
    this.surveyId = data.surveyId;
    this.validatorRemark = data.validatorRemark;
  }
}
